import { Container } from 'unstated';
import { getPersistentStore, getPersistentStoreMutex } from '@lemonadefashion/storage';

const KEY = 'activation';
function _getStore() { return getPersistentStore(); }
function _getMutex() { return getPersistentStoreMutex(); }

function getActivationFromStore() {
  try {
    const infoJson = _getStore().getItem(KEY);
    if (infoJson == null) return null;
    return JSON.parse(infoJson);
  } catch (error) {
    console.log(error);
    return null;
  }
}

function updateActivationInStore(activation) {
  return new Promise((resolve, reject) => {
    const mutex = _getMutex();
    const store = _getStore();
    mutex.lock(KEY)
      .then(() => {
        store.setItem(KEY, JSON.stringify(activation));
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

class ActivationContainer extends Container {
  constructor() {
    super();
    this.state = {
      activation: getActivationFromStore()
    };
    window.addEventListener('storage', e => {
      if (e.key !== KEY) return;
      this.setState({ activation: getActivationFromStore() });
    });
  }

  get() { return this.state.activation; }

  set(activation) {
    return new Promise((resolve, reject) => {
      updateActivationInStore(activation)
        .catch(console.log)
        .finally(() => this.setState({ activation: activation }, resolve));
    });
  }
}

export default ActivationContainer;
